var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 4.66667C10.6666 5.37391 10.3856 6.05219 9.88554 6.55229C9.38544 7.05238 8.70716 7.33333 7.99992 7.33333C7.29267 7.33333 6.6144 7.05238 6.1143 6.55229C5.6142 6.05219 5.33325 5.37391 5.33325 4.66667C5.33325 3.95942 5.6142 3.28115 6.1143 2.78105C6.6144 2.28095 7.29267 2 7.99992 2C8.70716 2 9.38544 2.28095 9.88554 2.78105C10.3856 3.28115 10.6666 3.95942 10.6666 4.66667ZM7.99992 9.33333C6.76224 9.33333 5.57526 9.825 4.70009 10.7002C3.82492 11.5753 3.33325 12.7623 3.33325 14H12.6666C12.6666 12.7623 12.1749 11.5753 11.2997 10.7002C10.4246 9.825 9.2376 9.33333 7.99992 9.33333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutline);
export default __webpack_public_path__ + "static/media/UserOutline.6089cfc37c248abe783b0ca59c4f1913.svg";
export { ForwardRef as ReactComponent };